/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetModifiableDailyLimitsForTheUserAccount200Response
 */
export interface GetModifiableDailyLimitsForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetModifiableDailyLimitsForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetModifiableDailyLimitsForTheUserAccount200Response
     */
    'limitType': GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetModifiableDailyLimitsForTheUserAccount200Response
     */
    'limit': number | null;
}

export const GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum = typeof GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum[keyof typeof GetModifiableDailyLimitsForTheUserAccount200ResponseLimitTypeEnum];


